import { cartTrackingDataPush, dispatchEventFunc } from "./analyticsUtils";

export const checkOutEvent = (activityId: any, shoppingItems: number[], cartData: any) => {
  const products = shoppingItems.map((id: number) => {
    const groups1 = cartData?.activity?.productGroup
    const groups2 = cartData?.exchange?.productGroup
    let item: any = null;
    groups1?.forEach((group: any) => {
      let temp = group.cartItems?.find((item: any) => item.id === id);
      if (temp) {
        item = temp;
      }
    });
    if (item) {
      const fPrice = item?.product?.finalPrice || item.product?.promoPrice || '0';
      return {
        name: item?.product.productName,
        catalogId: item?.product.sku,
        variant: item?.product.productSize,
        quantity: item?.quantity,
        price: fPrice ? Number(fPrice) * item?.quantity : '0'
      };
    }
    // If not found in the first group, check the second group
    if (!item) {
      groups2?.forEach((group: any) => {
        let temp = group.cartItems?.find((item: any) => item.id === id);
        if (temp) {
          item = temp;
        }
      });
    }
    if (item) {
      const fPrice = item?.product?.finalPrice || item.product?.promoPrice || '0';
      return {
        name: item?.product.productName,
        catalogId: item?.sku,
        variant: item?.product.productSize,
        quantity: item?.quantity,
        price: fPrice ? Number(fPrice) * item?.quantity : '0'
      };
    }
  });
  const payload = {
    id: activityId,
    products: products
  }
  dispatchEventFunc('checkoutStart', payload);
}

export const submitOrderEvent = (activityId: any, previewData: any) => {
  const checkoutProducts = previewData?.products?.map((item: any) => {
    return {
      name: item.product.productName,
      catalogId: item.sku,
      price: item.product.finalPrice ? (Number(item.product.finalPrice) * item.quantity).toFixed(2) : '0',
      quantity: item.quantity
    };
  });
  const payload = {
    id: activityId,
    products: checkoutProducts
  };
  dispatchEventFunc('submitOrder', payload);
}

export const deleteCartItemsEvent = (activityId: any, checkedCartItems: any, cartData: any) => {
  const removedProduts = checkedCartItems.map((id: any) => {
    const item = cartData.activity?.productGroup?.flatMap((group: any) => group.cartItems).find((item: any) => item.id === id);
    if (item) {
      return {
        name: item.product.productName,
        catalogId: item.product.sku,
        variant: item.product.productSize,
        quantity: item.quantity,
        price: item.finalPrice ? Number(item.finalPrice) * item.quantity : '0'
      };
    }
    // If not found in the first group, check the second group
    const exchangeItem = cartData.exchange?.productGroup?.flatMap((group: any) => group.cartItems).find((item: any) => item.id === id);
    if (exchangeItem) {
      return {
        name: exchangeItem.product.productName,
        catalogId: exchangeItem.sku,
        variant: exchangeItem.product.productSize,
        quantity: exchangeItem.quantity,
        price: exchangeItem.finalPrice ? Number(exchangeItem.finalPrice) * exchangeItem.quantity : '0'
      };
    }
    return null;
  }).filter((item: any) => item !== null);

  const dispatchObj = {
    method: 'delete products',
    products: removedProduts
  };
  cartTrackingDataPush({
    cartId: activityId,
    actionType: 'remove',
    dispatchObj
  })
}